import React, { useMemo } from 'react';
import classNames from 'classnames';

import { ISocketCommentProps } from "../../../../types/working-model";
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import Avatar from '../../../general-ui/avatar/avatar';

interface IChatFeedProps {
	comments: Map<number, ISocketCommentProps>;
}

const ChatFeed: React.FC<IChatFeedProps> = ({ comments }) => {

	const channel = useTypedSelector(state => state.LiveEventReducer.eventBundle?.channel);

	const renderComments = useMemo(() => {
		const comms: ISocketCommentProps[] = Array.from(comments.values());

		if (!comms) return null;
		return comms.map((comment, index) => {
			const isPrevUser = comms[index - 1]?.email === comment.email;
			const userInitials = `${comment?.first_name?.charAt(0)?.toUpperCase() || ''}${comment?.last_name?.charAt(0)?.toUpperCase() || ''}`;
			const avatar = channel && (comment?.registered_profile?.[channel]?.avatar || comment?.non_registered_profile?.[channel]?.avatar || comment?.profile?.[channel]?.avatar) || null;

			if (comment?.spam) return null;
			return (
				<div className={classNames("chat-comment", { 'user-continued': isPrevUser })} key={comment.id}>
					<Avatar imageUrl={avatar} initials={userInitials} />
					<div className="chat-comment-inner">
						{comment?.gif?.url && <img src={comment?.gif?.url} alt={comment?.gif?.title || 'gif'} width="100%" height="100%" />}
						{comment?.image?.url && <img src={comment?.image?.url} alt={comment?.image?.name || 'image'} width="100%" height="100%" />}
						<div className={classNames("chat-comment-meta")}>
							<span className="chat-comment-name">{comment.first_name} {comment.last_name}</span>
							<span className="chat-comment-date">{new Date(comment.created_at).toLocaleTimeString(navigator.language, { hour: 'numeric', minute: '2-digit' })}</span>
						</div>
						<div className="chat-comment-content">{comment.comment}</div>
					</div>
				</div>
			);
		});
	}, [comments, channel]);

	return (
		<div className="comment-feed-container">
			{renderComments}
		</div>
	);
};

ChatFeed.displayName = 'ChatFeed';

export default ChatFeed;
